import VSubheader from './VSubheader'

/* istanbul ignore next */
VSubheader.install = function install (Vue) {
  Vue.component(VSubheader.name, VSubheader)
}

export { VSubheader }
export default VSubheader
